<template>
    <section class="pr">
        <div :class="`swiper-box pf${diff}`">
            <swiper :options="options">
                <swiper-slide class="swiper-slide df">
                    <router-link :to="path" class="sort" exact>{{first}}</router-link>
                </swiper-slide>
                <swiper-slide v-for="(v, k) in sorts" :key="k" class="swiper-slide df">
                    <router-link :to="`/${path}?sort=${v.id}`" exact class="sort">{{v.name}}</router-link>
                </swiper-slide>
            </swiper>
        </div>
        <div class="nav-empty"></div>
    </section>
</template>

<script>
    export default {
        props: {
            sorts: Array,
            path: String,
            first: {
                type: String,
                default: '全部',
            },
        },
        data: () => ({
            options: {
                slidesPerView: 'auto',
                freeMode: true,
                freeModeSticky : true,
            },
            y: 0,
            diff: ' pa',
            has_timer: false,
        }),
        methods: {
            scroll() {// diff < 0 Scroll down
                const y = window.pageYOffset;
                if (this.has_timer) return this.y = y;

                this.has_timer = true;
                setTimeout(() => this.has_timer = false, 250);
                this.diff = y - this.y > 0 && y > 200 ? ' hidden' : '';
                this.y = y;
            }
        },
        mounted() {
            window.addEventListener('scroll', this.scroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.scroll);
        }
    }
</script>

<style scoped>
    @import '../../../static/css/base/nav.css';
</style>


// WEBPACK FOOTER //
// src/components/base/Nav.vue